const styleOverrides = {
  root: {
    padding: '0 0 4px',
    margin: 0,
  },
};

export default styleOverrides;
